export const initialDVLAVESState = {
    taxStatus: {},
};
export const DVLAVESActionTypes = {
    TAX_STATUS: '@@platform/dvlaves/TAX_STATUS',
};
